import React from 'react';
import { MaterialIcons } from '@expo/vector-icons';

interface EyeIconProps {
  isVisible: boolean;
  color?: string;
  size?: number;
}

const EyeIcon: React.FC<EyeIconProps> = ({
  isVisible,
  color = '#6B7280',
  size = 24,
}) => {
  return (
    <MaterialIcons
      name={isVisible ? 'visibility-off' : 'visibility'}
      size={size}
      color={color}
    />
  );
};

export default EyeIcon;
